<div class="mat-dialog-container">
  <h2 mat-dialog-title id="reset-dialog-title" class="dialog-title">
    <span class="title-text">Reset Password</span>
    <button mat-icon-button type="button" class="close-icon" id="reset-dialog-close-button" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <div class="notice notice-error" *ngIf="error">
      <div class="notice-body">Failed to reset password<br>{{ error?.description }}</div>
    </div>
    <div class="notice" *ngIf="success">
      <div class="notice-body">A new password has been emailed to you.</div>
    </div>

    <form [formGroup]="ResetForm" *ngIf="!success" class="material-form-grid">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput id="email" type="email" formControlName="email" />
      </mat-form-field>

      <ng-container *ngIf="gotQuestion">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Reset Question</mat-label>
          <input matInput id="resetQuestion" formControlName="resetQuestion" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Password Reset Answer</mat-label>
          <input matInput id="resetAnswer" formControlName="resetAnswer" />
          <mat-hint>If you do not know your reset answer, contact <a
              href="mailto:support@cristie.com?subject=New Portal Feedback">support&#64;cristie.com</a></mat-hint>
        </mat-form-field>
      </ng-container>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ng-container *ngIf="!success; else resetSuccessActions">
      <button mat-raised-button color="accent" id="reset-cancel-button" type="button" (click)="logout()">Cancel</button>
      <button mat-raised-button color="primary" id="reset-next-button" type="button" *ngIf="!gotQuestion" (click)="getResetQuestion()"
        [disabled]="nextDisabled()">
        <mat-spinner *ngIf="gettingQuestion" diameter="20" mode="indeterminate"></mat-spinner>
        {{ gettingQuestion ? 'Loading' : 'Next' }}
      </button>
      <button mat-raised-button color="primary" id="reset-submit-button" type="button" *ngIf="gotQuestion" (click)="resetPassword()"
        [disabled]="resetDisabled()">
        <mat-spinner *ngIf="resetting" diameter="20" mode="indeterminate"></mat-spinner>
        {{ resetting ? 'Resetting' : 'Reset' }}
      </button>
    </ng-container>
  </mat-dialog-actions>

  <ng-template #resetSuccessActions>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" id="reset-back-login-button" type="button" (click)="close()">Close</button>
    </mat-dialog-actions>
  </ng-template>
</div>
